import template from './trip-traveller-allocation-segment.html';

const DIRECTIVE_NAME = TripTravellerAllocationSegment.DIRECTIVE_NAME = 'ktTripTravellerAllocationSegment';
export default function TripTravellerAllocationSegment() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripTravellerAllocationSegmentController,
        controllerAs: '$ctrl',
        scope: {
            group: `=${DIRECTIVE_NAME}`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripTravellerAllocationSegmentController(
    userService,
    tripTravellerAllocationSegmentService,
    seatmapAvailabilityService,
    moment,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        toggleVisibility,
        moment,
        isSeatmapAvailableForFlight: seatmapAvailabilityService.isSeatmapAvailableForFlight,
    });

    function $onInit() {
        vm.isExpanded = false;
        initAirportCodes();
        initDepartureDate();
        vm.rs = userService.getRegionalSettings();
    }

    function initAirportCodes() {
        const route = tripTravellerAllocationSegmentService.getFlightSegmentAirportCodeRoute(vm.group);
        vm.firstAirportCode = tripTravellerAllocationSegmentService.getVeryFirstAirportCode(route);
        vm.lastAirportCode = tripTravellerAllocationSegmentService.getVeryLastAirportCode(route);

        const stopAirportCodes = tripTravellerAllocationSegmentService.getStopAirportCodes(route);
        vm.stopAirportCodes = stopAirportCodes && stopAirportCodes.join(' - ');
    }

    function initDepartureDate() {
        vm.departureDate = tripTravellerAllocationSegmentService.getDepartureDateForSegment(vm.group);
    }

    function toggleVisibility() {
        vm.isExpanded = !vm.isExpanded;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-segment-component.js